export const SET_BUS_INFO = 'SET_BUS_INFO';
export const REMOVE_BUS_INFO = 'REMOVE_BUS_INFO';